/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
import React, { useEffect, useRef, useState } from "react";
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  Button,
  Typography,
  useMediaQuery,
  createTheme,
  Skeleton,
  CircularProgress,
} from "@mui/material";

import { createBreakpoints } from "@mui/system";

import { serviceFetchProductList } from "../../api/service/services";
import { AxiosError, AxiosResponse } from "axios";
import DealsCard from "../common/DealsCard/DealsCard";
import "./ViewMore.css";
import { useNavigate } from "react-router-dom";

const DealPagination = () => {
  const navigate = useNavigate();

  const [cards, setCards] = useState<any>([]);
  const [rows, setRows] = useState(2); // Set initial rows to 2
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [totalProducts, setTotalProducts] = useState(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [showLoading, setShowLoading] = useState<boolean>(false);

  const prevOffset = useRef(offset);

  const customBreakpoints = createBreakpoints({
    values: {
      xs: 460,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  });

  const theme = createTheme({
    breakpoints: customBreakpoints,
  });
  const isXsScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const isSmScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMdScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isLgScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const isXlScreen = useMediaQuery(theme.breakpoints.down("xl"));

  let cardsPerRow = 5;
  if (isXsScreen) {
    cardsPerRow = 2;
  } else if (isSmScreen) {
    cardsPerRow = 2;
  } else if (isMdScreen) {
    cardsPerRow = 3;
  } else if (isLgScreen) {
    cardsPerRow = 4;
  } else if (isXlScreen) {
    cardsPerRow = 4; // or any other value you want for large and xl screens
  }

  useEffect(() => {
    const initialLimit = cardsPerRow * 2;
    const initialOffset = 0;
    //  fetchProductDetails(initialLimit, initialOffset);
    const storedDeals = sessionStorage.getItem("deals");
    const storedTotalDeals = sessionStorage.getItem("totalDeals");

    if (storedDeals) {
      const parsedDeals = JSON.parse(storedDeals);

      // Check if it's nested and flatten it
      const flattenedDeals = Array.isArray(parsedDeals[0])
        ? parsedDeals.flat()
        : parsedDeals;

      setCards(flattenedDeals);
      setTotalProducts(parseInt(storedTotalDeals || "0"));
      setLoading(false);
    } else {
      fetchProductDetails(initialLimit, initialOffset);
    }
    const clearSessionStorage = () => {
      sessionStorage.clear();
    };

    window.addEventListener("beforeunload", clearSessionStorage);

    return () => {
      window.removeEventListener("beforeunload", clearSessionStorage);
    };
  }, []);

  useEffect(() => {
    if (offset !== prevOffset.current) {
      fetchProductDetails(limit, offset);
      prevOffset.current = offset; // Update the previous offset
    }
  }, [offset]);

  useEffect(() => {}, [cards]);

  const fetchProductDetails = (limit: number, offset: number) => {
    serviceFetchProductList(limit, offset)
      .then((response: AxiosResponse) => {
        const newProducts = [response?.data?.data];

        setCards((prevCards: any) => [...prevCards, ...response?.data?.data]);
        // setCards(response?.data?.data)
        setLoading(false);
        setShowLoading(false);
        setTotalProducts(parseInt(response?.data?.total_items) || 10);
        sessionStorage.setItem("deals", JSON.stringify(newProducts));
        sessionStorage.setItem(
          "totalDeals",
          parseInt(response?.data?.total_items).toString()
        );
      })
      .catch((error: AxiosError) => {
        console.log("Error:", error.message);
        setLoading(false);
      });
  };

  const handleViewMore = () => {
    /*   setShowLoading(true);
    setRows((prevRows) => prevRows + 2);
    setLimit(2 * cardsPerRow);
    setOffset((prevOffset) => prevOffset + 2 * cardsPerRow); */
    navigate("/all-deals");
  };

  return (
    <div>
      <Accordion defaultExpanded style={{ boxShadow: "none",backgroundColor:"transparent" }}>
        <Typography
          id="top-deals-section"
          align="left"
          className="title-styles"
          //style={{ padding: "24px" }}
        >
          Top deals
        </Typography>
        <AccordionDetails sx={{ padding: 0 }}>
          {loading ? (
            <Skeleton variant="rounded" height={300} width="100%" />
          ) : (
            Array.from({ length: rows }, (_, rowIndex) => (
              <div
                key={rowIndex}
                style={{ display: "flex", gap: "8px", marginBottom: "40px" }}
              >
                {cards
                  .slice(rowIndex * cardsPerRow, (rowIndex + 1) * cardsPerRow)
                  .map((deal: any, index: number) => (
                    <DealsCard
                      // eslint-disable-next-line no-useless-escape
                      imageUrl={deal.product_images
                        ?.split("'")[1]
                        ?.replace(/[\[\]']/g, "")
                        ?.trim()}
                      title={deal.post_title}
                      price={deal.product_discounted_price}
                      originalPrice={deal.product_original_price}
                      retailerLogo={deal.retailer}
                      discount={deal.product_discount_percentage}
                      hoverText={"Save Upto"}
                      hoverPercentage={deal.product_discount_percentage}
                      id={deal.product_id}
                      productLink={deal.product_url_retailer}
                    />
                  ))}
              </div>
            ))
          )}
        </AccordionDetails>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <AccordionActions sx={{padding:'24px'}}>
            {totalProducts > cards.length && (
              <Button
                id="deal-view-more"
                onClick={handleViewMore}
                className="view-more-or-less"
                sx={{
                  fontWeight: 400,
                  verticalAlign:"middle",
    background: "linear-gradient(90deg, #FF1400 0%, #0F0E96 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    textFillColor: "transparent",
                }}
              >
                View More
              </Button>
              /*   <Button
                id="deal-view-more"
                onClick={handleViewMore}
                className="view-more-or-less"
                sx={{ width: "180px" }}
              >
                {showLoading ? (
                  <CircularProgress size={"20px"} />
                ) : (
                  "View More Deals"
                )}
              </Button> */
            )}
          </AccordionActions>
        </div>
      </Accordion>
      <br/>
    </div>
  );
};

export default DealPagination;
